// Superhive catalog tree picker: a jsTree (Checkbox, Search, Types,
// Wholerow) standing in for the old flat select2 <select>. One shared
// taxonomy payload (#js-central-catalog-tree-data, CentralCatalog.jstree_nodes)
// feeds every .js-catalog-tree on the page; each tree stays paired to its
// hidden <input class="js-catalog-tree-value"> by a shared id (data-target),
// not DOM proximity — a filing-table row's tree lives in a separate,
// full-width <tr> from its summary/hidden input (see _catalogs_tab.html.erb).
//
// Single-select, despite the checkbox UI: checking a node unchecks whatever
// else was checked in that tree (radio semantics via the checkbox plugin —
// see check_node.jstree below). Root nodes (organizational headings, not
// filing targets — CentralCatalog::MIN_FILING_DEPTH) are excluded from
// selection entirely; their checkbox is hidden in theme/_jstree.scss, and
// the check_node handler double-checks server-side intent client-side too.
// Checking a node also marks its whole ancestor chain (markAncestors below)
// so the path to it reads as selected, in a lighter, inert checkbox style.

var rawNodes = null

function loadNodes() {
  if (rawNodes) return rawNodes
  var script = document.getElementById("js-central-catalog-tree-data")
  rawNodes = script ? JSON.parse(script.textContent) : []
  return rawNodes
}

function findNode(nodes, id) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].id === id) return nodes[i]
  }
  return null
}

function findByPath(nodes, path) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].data && nodes[i].data.path === path) return nodes[i]
  }
  return null
}

function ancestorIds(nodes, id) {
  var ids = []
  var node = findNode(nodes, id)
  while (node && node.parent && node.parent !== "#") {
    ids.push(node.parent)
    node = findNode(nodes, node.parent)
  }
  return ids
}

// Marks every ancestor of a checked node so its whole path reads as
// selected (a lighter, non-interactive checkbox — see
// .jstree-ancestor-checked in theme/_jstree.scss) — otherwise picking a
// deeply-nested catalog would leave its parent chain looking untouched.
function markAncestors($tree, id) {
  var instance = $tree.jstree(true)
  ancestorIds(loadNodes(), id).forEach(function (ancestorId) {
    var li = instance.get_node(ancestorId, true)
    if (li) li.addClass("jstree-ancestor-checked")
  })
}

function clearAncestorMarks($tree) {
  $tree.find(".jstree-ancestor-checked").removeClass("jstree-ancestor-checked")
}

function hiddenInputFor(target) {
  return document.getElementById(target)
}

function summaryFor(target) {
  return document.querySelector(
    '.js-catalog-tree-summary[data-target="' + target + '"]'
  )
}

function treeFor(target) {
  return $('.js-catalog-tree[data-target="' + target + '"]')
}

// The clear link only shows while a catalog is picked — with nothing to
// clear it just adds noise under the tree. ERB sets the initial state
// (d-none when selected is blank); this keeps it true afterwards.
function syncClearButton(target) {
  var input = hiddenInputFor(target)
  var panel = document.querySelector(
    '.js-catalog-tree-panel[data-target="' + target + '"]'
  )
  var clear = panel && panel.querySelector(".js-catalog-tree-clear")
  if (input && clear) clear.classList.toggle("d-none", !input.value)
}

// Pushes a check/uncheck out to the paired hidden input and (when present)
// the collapsible row's summary text/needs-filing state. Guarded against
// no-ops so a resync triggered by our own "change" listener below doesn't
// re-trigger itself.
function setValue($tree, target, node) {
  var input = hiddenInputFor(target)
  if (!input) return

  var path = node ? node.data.path : ""
  if (input.value === path) return

  input.value = path
  $(input).trigger("change")

  var summary = summaryFor(target)
  if (summary) summary.textContent = path || summary.dataset.blankLabel

  // Swaps the needs_filing_label button for the normal summary+pencil (or
  // back) the moment a catalog is picked or cleared — no reload needed.
  var wrapper = input.closest(".catalog-tree-picker")
  if (wrapper) wrapper.classList.toggle("catalog-tree-picker-unfiled", !path)
}

// Unchecks node-by-node rather than uncheck_all: jsTree's uncheck_all
// fires only its own uncheck_all.jstree event — never per-node
// uncheck_node — so it would bypass the uncheck_node handler below and
// leave the hidden input, checkedId, and the ancestor marks all stale.
function clearTree($tree) {
  var instance = $tree.jstree(true)
  if (!instance) return

  instance.get_checked().forEach(function (id) {
    instance.uncheck_node(id)
  })
}

// Opens a node's ancestors and checks it (or clears the tree when path is
// blank) — used both for first-load preselection and to react when
// something outside the tree changes the hidden input's value (e.g.
// assets_table.js priming the shared edit modal for a different asset via
// `.value = ...; $(input).trigger("change")`).
function syncTreeToPath($tree, path) {
  var instance = $tree.jstree(true)
  if (!instance) return

  var nodes = loadNodes()
  var node = path ? findByPath(nodes, path) : null
  if (!node) {
    clearTree($tree)
    return
  }

  ancestorIds(nodes, node.id).forEach(function (id) {
    instance.open_node(id)
  })
  instance.check_node(node.id)
}

function initTree($tree) {
  if ($tree.data("catalogTreeInited")) return
  $tree.data("catalogTreeInited", true)

  var target = $tree.data("target")
  // Mirrors include_blank on the server side: a filing-table row that's
  // already filed posts blank as "keep current filing" (remap_mappings
  // drops blanks), so letting its check be cleared would silently no-op.
  var allowBlank = $tree.data("allowBlank") !== false
  var checkedId = null

  function reapplyAncestorMarks() {
    clearAncestorMarks($tree)
    if (checkedId) markAncestors($tree, checkedId)
  }

  $tree.jstree({
    core: {
      data: loadNodes(),
      themes: { dots: false, icons: true },
      multiple: false,
      // Node text is deliberately HTML (CentralCatalog.jstree_nodes pairs a
      // catalog's name with an "in <ancestor path>" span) — force_text
      // would escape and flatten that into a literal, visible <span> tag.
      force_text: false,
    },
    // "types" doesn't set icons here (those come from each node's own
    // `icon`, set server-side in CentralCatalog.jstree_nodes) — it's what
    // makes `data.node.type` resolve at all in the check_node handler
    // below (how a root/heading node gets rejected), and li_attr.class is
    // the hook theme/_jstree.scss uses to reveal a catalog node's checkbox
    // on hover (types don't add a class on their own otherwise).
    plugins: ["checkbox", "search", "types", "wholerow"],
    types: {
      root: {},
      catalog: { li_attr: { class: "jstree-catalog-type" } },
    },
    checkbox: {
      three_state: false,
      cascade: "",
      tie_selection: false,
      whole_node: true,
    },
    search: {
      show_only_matches: true,
      show_only_matches_children: true,
      search_callback: function (str, node) {
        var path = (node.data && node.data.path) || node.text
        return path.toLowerCase().indexOf(str.toLowerCase()) !== -1
      },
    },
  })

  $tree.on("ready.jstree", function () {
    // jsTree renders a nameless tree widget — hand it the row/field label
    // the ERB passed down (the hidden value input can't carry it: hidden
    // inputs are invisible to assistive tech).
    var ariaLabel = $tree.attr("data-aria-label")
    if (ariaLabel) {
      var $role = $tree.find('[role="tree"]').addBack('[role="tree"]')
      ;($role.length ? $role : $tree).attr("aria-label", ariaLabel)
    }

    syncTreeToPath($tree, $tree.data("selectedPath"))
  })

  $tree.on("check_node.jstree", function (event, data) {
    var instance = $tree.jstree(true)

    // Roots are organizational headings, not filing targets — never
    // checkable, even via a whole-row click.
    if (data.node.type === "root") {
      instance.uncheck_node(data.node)
      return
    }

    // Reassign checkedId before unchecking the old node, so the
    // uncheck_node handler below can tell this radio-style switch (ignore)
    // from a user clearing the current pick outright (handle).
    var previous = checkedId
    checkedId = data.node.id
    if (previous && previous !== data.node.id) {
      instance.uncheck_node(previous)
    }
    setValue($tree, target, data.node)
    reapplyAncestorMarks()
  })

  $tree.on("uncheck_node.jstree", function (event, data) {
    if (checkedId !== data.node.id) return

    // data.event is only set for user gestures — a filed filing-row can't
    // be cleared to blank (blank means "keep current" server-side), so put
    // the check straight back. Programmatic clears (syncTreeToPath
    // reacting to external value changes) always go through.
    if (data.event && !allowBlank) {
      $tree.jstree(true).check_node(data.node)
      return
    }

    checkedId = null
    setValue($tree, target, null)
    clearAncestorMarks($tree)
  })

  // Search (and re-opening a searched-away branch) redraws nodes from
  // scratch, rebuilding each <li>'s classes purely from model li_attr —
  // which silently drops the runtime-added ancestor marks.
  $tree.on(
    "search.jstree clear_search.jstree after_open.jstree",
    reapplyAncestorMarks
  )
}

$(document).on("turbolinks:load", function () {
  // The payload is page-specific (one asset library's taxonomy view) — drop
  // any cached copy from a previous page.
  rawNodes = null

  // Every current call site's tree is either inside a collapsible filing
  // row (lazily inited on first expand) or inside a modal (inited on first
  // show) — this only catches a tree rendered directly into normal flow.
  $(".js-catalog-tree").each(function () {
    var $tree = $(this)
    if ($tree.closest(".js-catalog-tree-row, .modal").length === 0) {
      initTree($tree)
    }
  })
})

// Bootstrap's modal focus trap and display:none sizing make jsTree
// unusable if initialized before the modal is shown — wait for it, exactly
// once per modal open (initTree no-ops after the first call).
$(document).on("shown.bs.modal", ".modal", function () {
  $(this)
    .find(".js-catalog-tree")
    .each(function () {
      var $tree = $(this)
      initTree($tree)
      // Re-opening the shared modal for a different asset: form.reset()
      // blanks the search box without an input event, so the previous
      // asset's filter would otherwise stay applied to the tree.
      resetSearch($tree)
    })
})

// Previews a checkable node's checkbox on hover (theme/_jstree.scss draws
// it from this class) — jQuery's delegated mouseenter/mouseleave fire only
// for the specific matched anchor being entered/left, not for bubbling out
// of a nested descendant the way plain CSS :hover would (a node's <li>
// contains its open children — see .jstree-node in theme/_jstree.scss).
$(document).on(
  "mouseenter",
  ".js-catalog-tree .jstree-catalog-type > .jstree-anchor",
  function () {
    $(this).addClass("jstree-anchor-hovered")
  }
)

$(document).on(
  "mouseleave",
  ".js-catalog-tree .jstree-catalog-type > .jstree-anchor",
  function () {
    $(this).removeClass("jstree-anchor-hovered")
  }
)

// A filing row's tree lives in a separate, full-width <tr> from its
// summary/toggle — open it (closing any other open row) and lazily init.
$(document).on("click", ".js-catalog-tree-toggle", function () {
  var target = this.dataset.target
  var $panel = $('.js-catalog-tree-panel[data-target="' + target + '"]')
  var $row = $panel.closest("tr.js-catalog-tree-row")
  var opening = $row.hasClass("d-none")

  $(".js-catalog-tree-row").not($row).addClass("d-none")
  $row.toggleClass("d-none", !opening)

  if (opening) initTree($panel.find(".js-catalog-tree"))
})

var searchTimers = new WeakMap()

// Blanks the search box and drops its filter from the tree, including any
// debounce still in flight.
function resetSearch($tree) {
  var input = $tree
    .closest(".catalog-tree-picker-panel")
    .find(".js-catalog-tree-search")[0]
  if (!input) return

  clearTimeout(searchTimers.get(input))
  input.value = ""
  if ($tree.jstree(true)) $tree.jstree("clear_search")
}

$(document).on("input", ".js-catalog-tree-search", function () {
  var input = this
  var $tree = $(input)
    .closest(".catalog-tree-picker-panel")
    .find(".js-catalog-tree")

  clearTimeout(searchTimers.get(input))
  searchTimers.set(
    input,
    setTimeout(function () {
      $tree.jstree("search", input.value)
    }, 200)
  )
})

// The search box lives inside submit-bearing forms (the filing form, the
// bulk/edit modals) — without this, Enter mid-search implicitly submits
// the whole form (the old select2 widget swallowed Enter itself).
$(document).on("keydown", ".js-catalog-tree-search", function (event) {
  if (event.key === "Enter") event.preventDefault()
})

$(document).on("click", ".js-catalog-tree-clear", function () {
  var $tree = $(this)
    .closest(".catalog-tree-picker-panel")
    .find(".js-catalog-tree")
  clearTree($tree)
})

// Anything outside the tree (assets_table.js priming the shared edit modal
// for a different asset, a plain form.reset()) that changes the hidden
// input's value and tells us via "change" — mirrors select2's old contract
// (see assets_table.js's "$(...).trigger('change')" comment).
$(document).on("change", ".js-catalog-tree-value", function () {
  // Every value change funnels through here — setValue triggers "change"
  // itself, and external primes are the change contract — so this is the
  // one spot that keeps the clear link's visibility honest.
  syncClearButton(this.id)

  var $tree = treeFor(this.id)
  if (!$tree.length) return

  $tree.data("selectedPath", this.value)
  if ($tree.data("catalogTreeInited")) syncTreeToPath($tree, this.value)
})

// .on, not .one — this must run before every cache, or Turbolinks
// snapshots live jsTree markup that the restore then double-initializes
// over (see the same pattern in image_cropper.js / assets_table.js).
$(document).on("turbolinks:before-cache", function () {
  $(".js-catalog-tree").each(function () {
    var $tree = $(this)
    if ($tree.data("catalogTreeInited")) $tree.jstree("destroy")
  })
})
